import React from "react";
import Modal from "./modal/ModalComponent";

const SecurityQuestion = () => {
  return (
    <div className="transition-all duration-1000 ease-in-out">
      <Modal
        isClose={false}
        userId={""}
        otpTimer={0}
        otpType={""}
        type="REDIRECT"
        header="🔒 Security Questions Required"
        transType="redirect"
      ></Modal>
    </div>
  );
};

export default SecurityQuestion;
